function getPortalId(): string {
  try {
    const portal = JSON.parse(localStorage.getItem('portal'));
    if (typeof portal === 'string' && portal.trim().length) return portal.trim();
  } catch {
    // ignore
  }
  return 'internal';
}

export function portalScopedKey(baseKey: string, portalId: string = getPortalId()): string {
  return `cpm:${portalId}:${baseKey}`;
}

export function getPortalRaw(baseKey: string): string | null {
  const key = portalScopedKey(baseKey);
  const scoped = localStorage.getItem(key);
  if (scoped !== null) return scoped;

  const legacy = localStorage.getItem(baseKey);
  if (legacy !== null) {
    localStorage.setItem(key, legacy); // one-time migration into portal scope
    return legacy;
  }
  return null;
}

export function setPortalRaw(baseKey: string, value: string): void {
  localStorage.setItem(portalScopedKey(baseKey), value);
}

export function clearPortalKey(baseKey: string): void {
  // Write explicit null so this portal no longer falls back to legacy keys.
  setPortalRaw(baseKey, 'null');
}

export function getPortalJson<T>(baseKey: string): T | undefined {
  const raw = getPortalRaw(baseKey);
  if (raw == null) return undefined;
  try {
    const parsed = JSON.parse(raw);
    return parsed ?? undefined;
  } catch {
    return undefined;
  }
}

export function setPortalJson(baseKey: string, value: any): void {
  setPortalRaw(baseKey, JSON.stringify(value));
}

